import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Image } from '@codes/ui-kit/components/ui/image';
import { Moon, Sun } from 'lucide-react';

import { EnDarkIcon, EnHoverIcon, EnIcon, KrDarkIcon, KrHoverIcon, KrIcon } from '@codes/assets';
import { useTheme } from '@codes/theme';

export const ToggleOption = () => {
    const { i18n } = useTranslation();
    const { theme, setTheme } = useTheme();
    const [language, setLanguage] = useState<string>(i18n.language || 'en');

    const handleThemeChange = () => {
        setTheme(theme === 'light' ? 'dark' : 'light');
    };
    const toggleLanguage = () => {
        const newLanguage = language === 'en' ? 'ko' : 'en';
        setLanguage(newLanguage);
        i18n.changeLanguage(newLanguage);
    };

    return (
        <div className="flex items-center gap-1">
            <button
                onClick={handleThemeChange}
                className="p-2 rounded-md hover:bg-hover transition-colors duration-150"
            >
                {theme === 'dark' ? (
                    <Sun className="w-[18px] h-[18px] text-text-500 hover:text-text" strokeWidth={1.75} />
                ) : (
                    <Moon className="w-[18px] h-[18px] text-text-500 hover:text-text" strokeWidth={1.75} />
                )}
            </button>
            <button
                className="relative p-2 rounded-md hover:bg-hover transition-colors duration-150"
                onClick={toggleLanguage}
            >
                <Image
                    className="w-5 h-5 block hover:opacity-0"
                    src={language === 'en' ? KrIcon : EnIcon}
                    darkSrc={language === 'en' ? KrDarkIcon : EnDarkIcon}
                    alt={language === 'en' ? 'Korean' : 'English'}
                />
                <Image
                    className="w-5 h-5 absolute top-2 left-2 opacity-0 hover:opacity-100"
                    src={language === 'en' ? KrHoverIcon : EnHoverIcon}
                    alt={language === 'en' ? 'Korean' : 'English'}
                />
            </button>
        </div>
    );
};
